import { Component } from "@angular/core";
import { ForgeIconButtonModule, ForgeIconModule, ForgeTooltipModule } from "@tylertech/forge-angular";
import { MetadataTextButtonComponent } from "./metadata-text-button.component";

@Component({
    selector: "metadata-generic-button",
    templateUrl: "./metadata-generic-button.tmpl.html",
    imports: [
        ForgeIconButtonModule,
        ForgeIconModule,
        ForgeTooltipModule,
    ]
})
export class MetadataGenericButtonComponent extends MetadataTextButtonComponent
{

    get CanEdit(): boolean
    {
        return !!this.model && this.allowEdit() && !this.viewOnly;
    }

}
